export const odluka_o_rasporedu_koristenja_godisnjeg_odmora = {
    templateId: 28,
    category: 3,
    templateTitle: 'Odluka o rasporedu korištenja godišnjeg odmora',
    templateDescription: `<p>Obveza poslodavca je utvrditi raspored korištenja godišnjeg odmora najkasnije do 30. lipnja tekuće godine. O rasporedu radnog vremena poslodavac odlučuje samostalno. Ipak, za poslodavce kod kojih je utemeljeno radničko vijeće ili djeluje sindikalni povjerenik, postoji obveza savjetovanja s istima, prije donošenja odluke. </p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Raspored korištenja godišnjeg odmora utvrđuje poslodavac, u skladu s ugovorom o radu i Zakonom o radu te kolektivnim ugovorom i pravilnikom o radu (ukoliko su usvojeni i primjenjuju se kod Poslodavca), najkasnije do 30. lipnja tekuće godine.</p>
    <p>Pri utvrđivanju rasporeda korištenja godišnjeg odmora moraju se uzeti u obzir potrebe organizacije rada te mogućnosti za odmor raspoložive radnicima.</p>
    <p>Odlukom se obuhvaća pravo na godišnji odmor radnika koji su ostvarili pravo na puni godišnji odmor kod poslodavca.</p>
    <p>Zbog spomenutog u prethodnoj rečenici, ovom Odlukom o rasporedu korištenja godišnjeg odmora ne određuje se raspored korištenja godišnjeg odmora radnika koji se prvi put zaposle i koji nisu radili neprekidno šest mjeseci kod tog poslodavca ili koji imaju prekid između dva radna odnosa duži od osam dana, jer isti nisu ostvarili pravo na puni godišnji odmor.</p>
    <p>Zakonom o radu propisano je najkraće trajanje godišnjeg odmora pa tako radnik ima za svaku kalendarsku godinu pravo na godišnji odmor od najmanje četiri tjedna, a maloljetnik i radnik koji radi na poslovima na kojima, uz primjenu mjera zaštite zdravlja i sigurnosti na radu, nije moguće zaštititi radnika od štetnih utjecaja u trajanju od najmanje pet tjedana.</p>
    <p>Kolektivnim ugovorom, sporazumom sklopljenim između radničkog vijeća i poslodavca, pravilnikom o radu ili ugovorom o radu može se utvrditi trajanje godišnjeg odmora duže od najkraćega propisanog Zakonom o radu.</p>
    <p><strong>Radnik ostvaruje pravo na godišnji odmor prema rasporedu radnog vremena u kojemu radi. Dakle, ukoliko radnik radi u peterodnovnom rasporedu radnog vremena, ostvaruje pravo na godišnji odmor od pet radnih dana tjedno, a ukoliko radnik radi u šesterodnevnom rasporedu radnog vremena, ostvaruje pravo na godišnji odmor od šest radnih dana tjedno.</strong></p>
    <p>Ako je kod poslodavca utemeljeno radničko vijeće odnosno ukoliko postoji sindikalni povjerenik, poslodavac se mora savjetovati s radničkim vijećem/sindikalnim povjerenikom o namjeravanoj odluci te mora radničkom vijeću/sindikalnom povjereniku dostaviti podatke važne za donošenje odluke o rasporedu korištenja godišnjih odmora i sagledavanje njezina utjecaja na položaj radnika.</p>
    <p>Ako kod poslodavca nije utemeljeno radničko vijeće, no djeluje sindikalni povjerenik, isti preuzima sva prava i obveze radničkog vijeća.</p>
    <p>Radničko vijeće/sindikalni povjerenik u tom smislu je dužan u roku od osam dana od obavijesti i dostavi svih podataka važnih za donošenje odluke, dostaviti svoje očitovanje o namjeravanoj odluci poslodavca.</p>
    <p><strong>Ako se radničko vijeće/sindikalni povjerenik ne očituje o namjeravanoj odluci u navedenom roku, smatra se da nema primjedbi i prijedloga.</strong></p>
    <p><strong>Važno je naglasiti da poslodavac nije vezan očitovanjem radničkog vijeća/sindikalnog povjenika te svoju odluku može donijeti čak iako se navedeni protive istoj, no dužan je savjetovati se, jer je u protivnom odluka ništetna (ne proizvodi pravne učinke).</strong></p>
    
    <h5><strong>SVRHA DOKUMENTA</strong></h5>
    <p>Svrha dokumenta je planiranje godišnjih odmora, kako za poslodavca, tako i za radnika. Dakle, navedena odluka predstavlja plan, a stvarno korištenje godišnjih odmora može biti drugačije u odnosu na datume navedene u samoj Odluci.</p>
    <p>Pri donošenju ove odluke odnosno planu korištenja godišnjeg odmora treba uzeti u obzir da se blagdani i neradni dani određeni zakonom, razdoblje privremene nesposobnosti za rad koje je utvrdio ovlašteni liječnik te dani plaćenog dopusta, ne uračunavaju u trajanje godišnjeg odmora.</p>

    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Obavijest o rasporedu korištenja godišnjeg odmora nije donesena pravovremeno (do 30. lipnja) - prekršaj</strong></p>
    <p>Pojašnjenje: zakonska obveza poslodavca je donijeti odluku o rasporedu korištenja godišnjeg odmora do 30. lipnja.</p>
    <p><strong>- Tumačenje da kod korištenja godišnjih odmora postoji obveza pridržavanja plana korištenja godišnjih odmora navedenog u Odluci o rasporedu korištenja godišnjeg odmora</strong></p>
    <p>Pojašnjenje: godišnji odmori navedeni u Odluci o rasporedu korištenja godišnjih odmora ne moraju nužno biti realizirani na iste datume kako je to naznačeno Odlukom, nego stvarno ostvarenje godišnjih odmora može odstupati od datuma naznačenih u Odluci o rasporedu korištenja godišnjih odmora.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o radu.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o radu,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O RASPOREDU I KORIŠTENJU GODIŠNJEG ODMORA ZA ____________ GODINU',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            editable: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Uzimajući u obzir potrebe organizacije rada i mogućnosti za odmor i razonodu raspoložive zaposlenicima utvrđuje se za'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godinu sljedeći raspored korištenja godišnjeg odmora (dalje u tekstu, skraćeno: GO).'},],
                        help: 'Ako radnik koristi godišnji odmor u dijelovima, mora tijekom kalendarske godine za koju ostvaruje pravo na godišnji odmor iskoristi najmanje dva tjedna u neprekidnom trajanju, osim ako se radnik i poslodavac drukčije ne dogovore, pod uvjetom da je ostvario pravo na godišnji odmor u trajanju dužem od dva tjedna..',
                    }],
            value: '',
        },
        {
            title: '',
            type: "text",
            mandatory: true,
            editable: true,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: '1. Radnik ___________________, ostvario je pravo na _____ dana godišnjeg odmora te će glavni dio GO (dva tjedna)  koristiti u periodu od ________ do ________ godine;  II. dio godišnjeg odmora će koristiti od _____ do _______ godine, treći dio godišnjeg odmora će koristiti od ________ do _______ godine.',
                    help: 'Vezano uz Pomoć(?) u prethodnoj točki, napominjemo da je obvezno korištenje glavnog dijela godišnjeg odmora u godini u kojoj je ostvaren. Osim toga, II. i III. dio GO nije obvezno navoditi u ovoj odluci te se isti može koristiti i u sljedećoj kalendarskoj godini.  Blagdani i neradni dani određeni zakonom, razdoblje privremene nesposobnosti za rad koje je utvrdio ovlašteni liječnik, te dani plaćenog dopusta, ne uračunavaju se u trajanje godišnjeg odmora.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            editable: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Svaki pojedini radnik iz ove Odluke, preostali dio godišnjeg odmora će koristiti u dogovoru s Poslodavcem i/ili prema utvrđenom planu korištenja godišnjih odmora.',
                    value: '',
                },
                {
                    type: "text",
                    mandatory: true,
                    editable: false,
                    content: "\r\nJedan dan godišnjeg odmora radnik ima pravo koristiti kada on to želi (osim ako posebno opravdani razlozi na strani poslodavca to onemogućuju), uz obvezu da o tome obavijesti Poslodavca najmanje tri dana prije njegovog korištenja, ako kolektivnim ugovorom nije određen drugačiji rok.",
                    value: '',
                },
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Radnika se mora najmanje petnaest dana prije korištenja godišnjeg odmora obavijestiti o trajanju godišnjeg odmora i razdoblju njegovog korištenja.',
                    help: 'Za navedeno je potrebno donijeti posebno odluku o korištenju godišnjeg odmora za svakog radnika i za svako pojedino korištenje godišnjeg odmora prema primjeru Odluke o korištenju godišnjeg odmora.',
                    value: '',
                },
                {
                    type: "text",
                    mandatory: true,
                    editable: false,
                    content: "\r\nBlagdani i neradni dani određeni zakonom, razdoblje privremene nesposobnosti za rad koje je utvrdio ovlašteni liječnik, te dani plaćenog dopusta, ne uračunavaju se u trajanje godišnjeg odmora.",
                    value: '',
                },],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: false,
                    content: 'Za vrijeme korištenja godišnjeg odmora radnik ima pravo na naknadu plaće u iznosu određenom ugovorom o radu ili pravilnikom o radu, a najmanje u visini njegove prosječne mjesečne plaće u prethodna tri mjeseca (uračunavajući sva primanja u novcu i naravi koja predstavljaju naknadu za rad).',
                    value: '',
                }],
        },
        {
            title: "",
            mandatory: false,
            statements: [
              {
                type: "choice",
                mandatory: true,
                editable: false,
                choices: [
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke u te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće pozitivno očitovalo dana " },
                      { type: "input", value: "", required: true, help: "Prije donošenja ove Odluke, poslodavac se dužan savjetovati s radničkim vijećem, ukoliko isto postoji kod poslodavca. Radničko vijeće je dužno u roku od osam dana, dostaviti poslodavcu svoje očitovanje o namjeravanoj odluci." },
                    ]
                  },
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik očitovao pozitivno dana " },
                      { type: "input", value: "", required: true, help: "Ako kod poslodavca nije utemeljeno radničko vijeće, a kod Poslodavca djeluje sindikalni povjerenik, isti preuzima sva prava i obveze radničkog vijeća te je u tom smislu dužan ju roku od osam dana dostaviti svoje očitovanje o namjeravanoj odluci poslodavcu. U tom smislu, Poslodavac je dužan prije ove Odluke, prethodno se savjetovati sa sindikalnim povjerenikom." },
                    ]
                  },
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće nije očitovalo u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
                    ]
                  },
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik nije očitovao u roku određenom Zakonom o radu (8 dana) čime se smatra da nema primjedbi i prijedloga." },
                    ]
                  },
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio radničkom vijeću namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se radničko vijeće očitovalo negativno, no Poslodavac ipak donosi ovu Odluku." },
                    ]
                  },
                  {
                    parts: [
                      { type: "text", content: "Poslodavac je dana " },
                      { type: "input", value: "", required: true },
                      { type: "text", content: "godine priopćio sindikalnom povjereniku namjeru donošenja Odluke te iznio prijedlog sadržaja iste uz podatke koji su važni za donošenje odluke i sagledavanje njezina utjecaja na položaj radnika, o čemu se sindikalni povjerenik očitovao negativno, no Poslodavac ipak donosi ovu Odluku." },
                    ]
                  }],
              },
            ]
          },
        {
            mandatory: true,
            editable: true,
            statements: [
                {
                    title: '',
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    mandatory: true,
                                    editable: false,
                                    content: 'Ova Odluka objavljena je na oglasnoj ploči Poslodavca dana _______________ godine.',
                                    help: 'Radi postupanja u skladu sa Zakonom o radu, Odluka mora biti donesena najkasnije do 30. lipnja tekuće godine. Na crtu možete vlastoručno upisati datum objave na oglasnoj ploči Poslodavca.',
                                    value: '',
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    mandatory: true,
                                    editable: false,
                                    content: 'Svaki radnik će na posebnom potpisnom listu potpisati primitak ove Odluke.',
                                    value: '',
                                }
                            ]
                        },
                    ],
                    value: '',
                },
            ],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine.",
                    help: 'Sukladno Zakonu o radu, Odluka mora biti donesena najkasnije do 30. lipnja tekuće godine.',

                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radnicima \r\n2) Kadrovska služba',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/28_odluka_o_rasporedu_koristenja_godisnjeg_odmora.ts